export default "__VITE_ASSET__256d6b7c__"